var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageTit"},[_c('dl',[_c('dt',[_vm._v("\n      "+_vm._s(this.title)+"\n    ")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(this.description))])]),_vm._v(" "),_c('div',{staticClass:"brandBox"},[_c('ticket-brand-select')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae8c3de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/ticket/component/ticketlist/layout/ticket_header.vue
// module id = null
// module chunks = 